import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex justify-center items-center bg-black bg-opacity-30 z-50" }
const _hoisted_2 = { class: "bg-white dark:bg-gray-800 w-[40vw] max-h-[90vh] p-6 rounded-lg overflow-y-auto" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = { class: "flex mt-2 gap-2 overflow-auto" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex items-center justify-between mb-2" }
const _hoisted_10 = { class: "flex gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_12 = {
  key: 0,
  class: "text-red-500 text-sm mt-2"
}
const _hoisted_13 = {
  key: 1,
  class: "text-green-600 text-sm mt-2"
}
const _hoisted_14 = { class: "flex items-center gap-2 mb-4" }
const _hoisted_15 = { class: "border border-gray-300 rounded p-4 mb-4" }
const _hoisted_16 = {
  key: 2,
  class: "bg-gray-100 dark:bg-gray-700 p-3 rounded mt-2"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["onChange"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 3,
  class: "space-y-2"
}
const _hoisted_22 = { class: "block mb-2" }
const _hoisted_23 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_24 = { class: "space-y-2" }
const _hoisted_25 = { class: "flex items-center gap-2 text-sm text-black dark:text-white" }
const _hoisted_26 = { class: "text-gray-400" }
const _hoisted_27 = { class: "flex items-center gap-2" }
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = ["onClick", "disabled"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 1,
  class: "border border-gray-300 rounded p-4"
}
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "mt-4 space-y-2" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "flex justify-end mt-6 gap-3" }

import {
  ref, watch, computed,
} from 'vue';
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import { doc, updateDoc } from 'firebase/firestore';
import { db, storage } from '@/config/firebase';

export interface Service {
  id: string;
  docId: string;
  title: string;
  subTitle: string;
  category: string;
  description: string;
  coverImg: string;
  images: string[];
  config?: any;
}

type ServiceInputFieldOption = { label: string; image?: string };
type ServiceInputFieldType =
  | 'text'
  | 'dropdown'
  | 'multiselect'
  | 'datetime'
  | 'attachment'
  | 'carousel-select'
  | 'counter';
type ServiceInputField = {
  id: string;
  label: string;
  type: ServiceInputFieldType;
  placeholder?: string;
  // In saved config:
  // - dropdown/multiselect: string[]
  // - carousel-select: {label,image}[]
  options: string[] | ServiceInputFieldOption[] | null;
  required: boolean;
  icon?: string;
  min?: number;
  max?: number;
};
type ServicePriceRule = { if: Record<string, string>; add: number };
type ServiceConfig = {
  isPaymentFirst: boolean;
  fields: ServiceInputField[];
  price: {
    base: number;
    rules: ServicePriceRule[];
  };
};

type NewFieldState = {
  id: string;
  label: string;
  type: ServiceInputFieldType;
  placeholder: string;
  options: string | ServiceInputFieldOption[];
  required: boolean;
  icon: string;
  min: number;
  max: number;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'EditServiceModal',
  props: {
    service: {}
  },
  emits: ['close', 'updated'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const form = ref<Service>({ ...props.service });

const newCoverImgFile = ref<File | null>(null);
const newImageFiles = ref<File[]>([]);

const newCoverPreview = computed(() => (newCoverImgFile.value ? URL.createObjectURL(newCoverImgFile.value) : null));
const newImagesPreview = computed(() => newImageFiles.value.map((file) => URL.createObjectURL(file)));

const inputConfig = ref<ServiceConfig>(
  (props.service.config as ServiceConfig) || {
    isPaymentFirst: true,
    fields: [],
    price: {
      base: 0,
      rules: [],
    },
  },
);
console.log(JSON.stringify(inputConfig.value, null, 2));

const newField = ref<NewFieldState>({
  id: '',
  label: '',
  type: 'text',
  placeholder: '',
  options: '',
  required: false,
  icon: '',
  min: 0,
  max: 10,
});

const newRule = ref({
  conditions: [{ key: '', value: '' }],
  add: 0,
});

// JSON editor mode for config
const viewMode = ref<'builder' | 'json'>('builder');
const jsonConfig = ref<string>(JSON.stringify(inputConfig.value, null, 2));
const jsonError = ref<string | null>(null);
const jsonSuccess = ref<string | null>(null);

watch(viewMode, (mode) => {
  if (mode === 'json') {
    jsonConfig.value = JSON.stringify(inputConfig.value, null, 2);
    jsonError.value = null;
    jsonSuccess.value = null;
  }
});

function applyJsonConfig() {
  try {
    const parsed = JSON.parse(jsonConfig.value);
    inputConfig.value = parsed as ServiceConfig;
    jsonError.value = null;
    jsonSuccess.value = 'JSON applied to configuration.';
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : String(e);
    jsonError.value = `Invalid JSON: ${message}`;
    jsonSuccess.value = null;
  }
}

// Keep newField.options shape consistent with selected type
watch(
  () => newField.value.type,
  (t) => {
    if (t === 'carousel-select') {
      if (!Array.isArray(newField.value.options)) newField.value.options = [];
    } else if (Array.isArray(newField.value.options)) {
      newField.value.options = '';
    }
  },
);

function carouselOptions(): ServiceInputFieldOption[] {
  return Array.isArray(newField.value.options)
    ? (newField.value.options as ServiceInputFieldOption[])
    : [];
}

// Helper
function resizeImage(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    img.onload = () => {
      const aspectRatio = img.width / img.height;
      canvas.width = Math.min(img.width, 1250);
      canvas.height = canvas.width / aspectRatio;

      if (ctx) {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (blob) {
            const resizedFile = new File([blob], file.name, {
              type: file.type,
            });
            resolve(resizedFile);
          } else {
            reject(new Error('Canvas to Blob failed'));
          }
        }, file.type);
      } else {
        reject(new Error('No canvas context'));
      }
    };

    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

async function uploadFile(file: File): Promise<string> {
  const resized = await resizeImage(file);
  const fileRef = storageRef(storage, `services/${Date.now()}-${file.name}`);
  const snapshot = await uploadBytes(fileRef, resized);
  return getDownloadURL(snapshot.ref);
}

async function updateService() {
  try {
    const updates: Partial<Service> = {};

    // Replace cover image
    if (newCoverImgFile.value) {
      const isInImages = props.service.images.includes(props.service.coverImg);
      if (!isInImages) {
        await deleteObject(storageRef(storage, props.service.coverImg));
      }
      updates.coverImg = await uploadFile(newCoverImgFile.value);
    }

    // Replace additional images
    if (newImageFiles.value.length > 0) {
      const coverToKeep = props.service.coverImg;

      // delete only images that are NOT the cover image
      // eslint-disable-next-line no-restricted-syntax
      for (const url of props.service.images) {
        if (url !== coverToKeep) {
          // eslint-disable-next-line no-await-in-loop
          await deleteObject(storageRef(storage, url));
        }
      }

      const newUrls = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const file of newImageFiles.value) {
        // eslint-disable-next-line no-await-in-loop
        const url = await uploadFile(file);
        newUrls.push(url);
      }
      updates.images = newUrls;
    }
    console.log(inputConfig.value);
    // Other fields
    updates.config = inputConfig.value;
    updates.title = form.value.title;
    updates.subTitle = form.value.subTitle;
    updates.category = form.value.category;
    updates.description = form.value.description;

    await updateDoc(doc(db, 'services', props.service.docId), updates);
    alert('Service updated successfully!');
    emit('updated');
    emit('close');
  } catch (error) {
    console.error('Update failed:', error);
    alert('Update failed');
  }
}

function onFileChange(event: Event, type: string) {
  const target = event.target as HTMLInputElement;
  if (!target.files) return;
  if (type === 'coverImg') {
    // eslint-disable-next-line prefer-destructuring
    newCoverImgFile.value = target.files[0];
  } else if (type === 'images') {
    newImageFiles.value = Array.from(target.files);
  }
}

function moveField(index: number, direction: 'up' | 'down') {
  const fields = inputConfig.value.fields;
  if (
    (direction === 'up' && index === 0)
    || (direction === 'down' && index === fields.length - 1)
  ) return;

  const swapIndex = direction === 'up' ? index - 1 : index + 1;
  const temp = fields[swapIndex];
  fields[swapIndex] = fields[index];
  fields[index] = temp;
}

async function onCarouselImageUpload(event: Event, index: number) {
  const input = event.target as HTMLInputElement;
  if (!input.files?.[0]) return;

  const file = input.files[0];
  const url = await uploadFile(file);
  if (!Array.isArray(newField.value.options)) {
    newField.value.options = [];
  }
  (newField.value.options as ServiceInputFieldOption[])[index].image = url;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[42] || (_cache[42] = _createElementVNode("h2", { class: "text-xl font-bold mb-4" }, "Edit Service", -1)),
      _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block mb-2 font-medium" }, "Title", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
        class: "input"
      }, null, 512), [
        [_vModelText, form.value.title]
      ]),
      _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block mt-4 mb-2 font-medium" }, "SubTitle", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.subTitle) = $event)),
        class: "input"
      }, null, 512), [
        [_vModelText, form.value.subTitle]
      ]),
      _cache[45] || (_cache[45] = _createElementVNode("label", { class: "block mt-4 mb-2 font-medium" }, "Category", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.category) = $event)),
        class: "input"
      }, null, 512), [
        [_vModelText, form.value.category]
      ]),
      _cache[46] || (_cache[46] = _createElementVNode("label", { class: "block mt-4 mb-2 font-medium" }, "Description", -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.description) = $event)),
        class: "input",
        rows: "4"
      }, null, 512), [
        [_vModelText, form.value.description]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[26] || (_cache[26] = _createElementVNode("label", { class: "font-medium mb-2 block" }, "Replace Cover Image", -1)),
        _createElementVNode("input", {
          type: "file",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (onFileChange($event, 'coverImg')))
        }, null, 32),
        (newCoverPreview.value || form.value.coverImg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: newCoverPreview.value || form.value.coverImg,
                class: "w-60 rounded",
                alt: "TALAB service"
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[27] || (_cache[27] = _createElementVNode("label", { class: "font-medium mb-2 block" }, "Replace Additional Images", -1)),
        _createElementVNode("input", {
          type: "file",
          multiple: "",
          onChange: _cache[5] || (_cache[5] = ($event: any) => (onFileChange($event, 'images')))
        }, null, 32),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newImagesPreview.value.length
              ? newImagesPreview.value
              : form.value.images, (img, i) => {
            return (_openBlock(), _createElementBlock("img", {
              key: i,
              src: img,
              class: "w-32 h-20 object-cover rounded",
              alt: "TALAB service"
            }, null, 8, _hoisted_8))
          }), 128))
        ])
      ]),
      _cache[47] || (_cache[47] = _createElementVNode("hr", { class: "my-6 border-gray-400" }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Service Form Configuration", -1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (viewMode.value = 'builder')),
            class: _normalizeClass(['px-3 py-1 rounded text-sm', viewMode.value === 'builder' ? 'bg-indigo-600 text-white' : 'bg-gray-200 dark:bg-gray-700 dark:text-white'])
          }, " Builder ", 2),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (viewMode.value = 'json')),
            class: _normalizeClass(['px-3 py-1 rounded text-sm', viewMode.value === 'json' ? 'bg-indigo-600 text-white' : 'bg-gray-200 dark:bg-gray-700 dark:text-white'])
          }, " JSON ", 2)
        ])
      ]),
      (viewMode.value === 'json')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((jsonConfig).value = $event)),
              class: "input font-mono min-h-[260px]",
              spellcheck: "false"
            }, null, 512), [
              [_vModelText, jsonConfig.value]
            ]),
            (jsonError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(jsonError.value), 1))
              : _createCommentVNode("", true),
            (jsonSuccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(jsonSuccess.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", { class: "flex justify-end mt-3" }, [
              _createElementVNode("button", {
                class: "bg-indigo-600 text-white px-3 py-1 rounded",
                onClick: applyJsonConfig
              }, " Apply JSON ")
            ])
          ]))
        : _createCommentVNode("", true),
      (viewMode.value === 'builder')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_14, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "font-medium" }, "Show Payment Button:", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((inputConfig.value.isPaymentFirst) = $event))
              }, null, 512), [
                [_vModelCheckbox, inputConfig.value.isPaymentFirst]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[33] || (_cache[33] = _createElementVNode("h4", { class: "font-semibold mb-2" }, "Add New Input Field", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newField.value.id) = $event)),
                placeholder: "ID (e.g., documentType)",
                class: "input mb-2"
              }, null, 512), [
                [_vModelText, newField.value.id]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newField.value.label) = $event)),
                placeholder: "Label",
                class: "input mb-2"
              }, null, 512), [
                [_vModelText, newField.value.label]
              ]),
              (newField.value.type === 'text')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((newField.value.placeholder) = $event)),
                    placeholder: "Placeholder",
                    class: "input mb-2"
                  }, null, 512)), [
                    [_vModelText, newField.value.placeholder]
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((newField.value.type) = $event)),
                class: "input mb-2"
              }, _cache[30] || (_cache[30] = [
                _createStaticVNode("<option value=\"text\" data-v-e5305846>Text Input</option><option value=\"dropdown\" data-v-e5305846>Dropdown</option><option value=\"multiselect\" data-v-e5305846>Multi-Select</option><option value=\"datetime\" data-v-e5305846>Date/Time Picker</option><option value=\"attachment\" data-v-e5305846>Attachment</option><option value=\"carousel-select\" data-v-e5305846>Carousel Select</option><option value=\"counter\" data-v-e5305846>Counter</option>", 7)
              ]), 512), [
                [_vModelSelect, newField.value.type]
              ]),
              (newField.value.type === 'dropdown' || newField.value.type === 'multiselect')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((newField.value.options) = $event)),
                    placeholder: "Options (comma separated)",
                    class: "input mb-2"
                  }, null, 512)), [
                    [_vModelText, newField.value.options]
                  ])
                : _createCommentVNode("", true),
              (newField.value.type === 'carousel-select')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _cache[31] || (_cache[31] = _createElementVNode("h5", { class: "font-medium text-sm mb-2" }, "Carousel Options", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselOptions(), (opt, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "flex items-center mb-2 gap-2"
                      }, [
                        (opt.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: opt.image,
                              class: "w-12 h-12 object-cover rounded",
                              alt: "Image"
                            }, null, 8, _hoisted_17))
                          : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((opt.label) = $event),
                          placeholder: "Label",
                          class: "input flex-1"
                        }, null, 8, _hoisted_18), [
                          [_vModelText, opt.label]
                        ]),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/*",
                          onChange: ($event: any) => (onCarouselImageUpload($event, i)),
                          class: "input max-w-[140px]"
                        }, null, 40, _hoisted_19),
                        _createElementVNode("button", {
                          onClick: ($event: any) => ((newField.value.options as ServiceInputFieldOption[]).splice(i, 1)),
                          class: "text-red-500 hover:text-red-700 text-sm"
                        }, " ✕ ", 8, _hoisted_20)
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      class: "text-sm text-[#C59C2F] mt-2",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => ((newField.value.options as ServiceInputFieldOption[]).push({ label: '', image: '' })))
                    }, " + Add Option ")
                  ]))
                : _createCommentVNode("", true),
              (newField.value.type === 'counter')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newField.value.icon) = $event)),
                      placeholder: "Ionicon name (e.g., person)",
                      class: "input"
                    }, null, 512), [
                      [_vModelText, newField.value.icon]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newField.value.min) = $event)),
                      placeholder: "Min value",
                      class: "input"
                    }, null, 512), [
                      [
                        _vModelText,
                        newField.value.min,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((newField.value.max) = $event)),
                      placeholder: "Max value",
                      class: "input"
                    }, null, 512), [
                      [
                        _vModelText,
                        newField.value.max,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((newField.value.required) = $event)),
                  class: "mr-2"
                }, null, 512), [
                  [_vModelCheckbox, newField.value.required]
                ]),
                _cache[32] || (_cache[32] = _createTextVNode(" Required Field "))
              ]),
              _createElementVNode("button", {
                onClick: _cache[20] || (_cache[20] = 
              () => {
                console.log(newField.value.type);
                inputConfig.value.fields.push({
                  ...newField.value,
                  options: newField.value.options.length
                    ? newField.value.type === 'carousel-select'
                    ? (newField.value.options as ServiceInputFieldOption[])
                    : (newField.value.options as string).split(',').map((s) => s.trim())
                    : null,
                });
                newField.value.id = '';
                newField.value.label = '';
              (newField.value.placeholder = ''), (newField.value.options = '');
                newField.value.type = 'text';
                newField.value.required = false;
                newField.value.icon = '';
              }
            ),
                class: "bg-green-600 text-white px-3 py-1 rounded"
              }, " Add Field ")
            ]),
            (inputConfig.value?.fields?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "font-semibold mb-2" }, "Current Fields:", -1)),
                  _createElementVNode("ul", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputConfig.value.fields, (field, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: i,
                        class: "flex items-center justify-between bg-gray-100 dark:bg-gray-700 px-3 py-2 rounded"
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(field.label) + " ", 1),
                            _createElementVNode("span", _hoisted_26, "(" + _toDisplayString(field.type) + ")", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (moveField(i, 'up')),
                            disabled: i === 0,
                            class: "text-gray-500 hover:text-[#C59C2F] disabled:opacity-30",
                            title: "Move up"
                          }, " ▲ ", 8, _hoisted_28),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (moveField(i, 'down')),
                            disabled: i === inputConfig.value.fields.length - 1,
                            class: "text-gray-500 hover:text-[#C59C2F] disabled:opacity-30",
                            title: "Move down"
                          }, " ▼ ", 8, _hoisted_29),
                          _createElementVNode("button", {
                            onClick: () => inputConfig.value.fields.splice(i, 1),
                            class: "text-red-500 hover:text-red-700",
                            title: "Remove"
                          }, " ✕ ", 8, _hoisted_30)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (inputConfig.value.isPaymentFirst)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _cache[40] || (_cache[40] = _createElementVNode("h4", { class: "font-semibold mb-2" }, "Pricing Configuration", -1)),
                  _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block mb-2" }, "Base Price", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((inputConfig.value.price.base) = $event)),
                    class: "input mb-4"
                  }, null, 512), [
                    [_vModelText, inputConfig.value.price.base]
                  ]),
                  _createElementVNode("div", null, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block mb-1 font-medium" }, "Add Rule:", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newRule.value.conditions, (cond, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: "flex items-center gap-2 mb-2"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((cond.key) = $event),
                          placeholder: "Field ID",
                          class: "input flex-1"
                        }, null, 8, _hoisted_32), [
                          [_vModelText, cond.key]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((cond.value) = $event),
                          placeholder: "Expected Value",
                          class: "input flex-1"
                        }, null, 8, _hoisted_33), [
                          [_vModelText, cond.value]
                        ]),
                        (newRule.value.conditions.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (newRule.value.conditions.splice(idx, 1)),
                              class: "text-red-500"
                            }, " ✕ ", 8, _hoisted_34))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      class: "text-sm text-[#C59C2F] mb-3",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (newRule.value.conditions.push({ key: '', value: '' })))
                    }, " + Add Another Condition "),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((newRule.value.add) = $event)),
                      placeholder: "Price Add",
                      class: "input mb-2"
                    }, null, 512), [
                      [
                        _vModelText,
                        newRule.value.add,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: "bg-indigo-600 text-white px-3 py-1 rounded",
                      onClick: _cache[24] || (_cache[24] = 
                () => {
                  const ifObject = {};
                  newRule.value.conditions.forEach((c) => {
                    if (c.key && c.value) {
                      ifObject[c.key] = c.value;
                    }
                  });

                  if (Object.keys(ifObject).length) {
                    inputConfig.value.price.rules.push({
                      if: ifObject,
                      add: Number(newRule.value.add),
                    });
                  }

                  newRule.value.conditions = [{ key: '', value: '' }];
                  newRule.value.add = 0;
                }
              )
                    }, " Add Rule ")
                  ]),
                  _createElementVNode("ul", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputConfig.value.price.rules, (rule, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: i,
                        class: "flex justify-between items-center text-sm bg-gray-100 dark:bg-gray-700 px-3 py-2 rounded"
                      }, [
                        _createElementVNode("span", null, [
                          _cache[38] || (_cache[38] = _createTextVNode(" If ")),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(rule.if), ([key, val], j) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: key,
                              class: "inline-block"
                            }, [
                              _createElementVNode("strong", null, _toDisplayString(key), 1),
                              _cache[36] || (_cache[36] = _createTextVNode(" = \"")),
                              _createElementVNode("em", null, _toDisplayString(val), 1),
                              _cache[37] || (_cache[37] = _createTextVNode("\"")),
                              (j < Object.entries(rule.if).length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, " & "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          _cache[39] || (_cache[39] = _createTextVNode(" Add ")),
                          _createElementVNode("strong", null, "£" + _toDisplayString(rule.add), 1)
                        ]),
                        _createElementVNode("button", {
                          onClick: () => inputConfig.value.price.rules.splice(i, 1),
                          class: "text-red-500"
                        }, " Remove ", 8, _hoisted_37)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("button", {
          onClick: _cache[25] || (_cache[25] = ($event: any) => (emit('close'))),
          class: "bg-gray-300 px-4 py-2 rounded"
        }, " Cancel "),
        _createElementVNode("button", {
          onClick: updateService,
          class: "bg-indigo-600 text-white px-4 py-2 rounded"
        }, " Save Changes ")
      ])
    ])
  ]))
}
}

})